let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jqpIK")).then(() => parcelRequire('ebeg1'));